import AccountCircle from "@material-ui/icons/AccountCircle";

import Group from "@material-ui/icons/People";

import SportsHandball from "@material-ui/icons/SportsHandball";

import EventIcon from "@material-ui/icons/Event";

import authors from "../components/screens/author";

import Plan from "../components/screens/plan";
import MovieFilter from "@material-ui/icons/MovieFilter";
import habits from "../components/screens/habits";
import customers from "../components/screens/customers";
import {
  BookRounded,
  FormatQuoteOutlined,
  BarChart,
} from "@material-ui/icons";
import quotes from "../components/screens/quotes";
import events from "../components/screens/events";
import notifications from "../components/screens/notifications";
import leadMagnets from "../components/screens/leadMagnets";
import CardGiftcard from "@material-ui/icons/CardGiftcard";
import Settings from "@material-ui/icons/Settings";
import configScreen from "../components/screens/config";
import analytics from "../components/screens/analytics";
import mediaStudio from "../components/screens/mediaStudio";
import Forum from "@material-ui/icons/Forum";
import board from "../components/screens/board";
import ViewColumn from "@material-ui/icons/ViewColumn";
import brain from "../components/screens/brain";
import BubbleChart from "@material-ui/icons/BubbleChart";

const items = [
  {
    Icon: BarChart,
    title: "Analytics",
    route: "/analytics",
    component: analytics,
    permission: [],
  },
  {
    Icon: BookRounded,
    title: "Plans",
    component: Plan,
    route: "/plans",
    permission: [],
  },
  {
    Icon: AccountCircle,
    title: "Authors",
    route: "/authors",
    component: authors,
    permission: [],
  },
  {
    Icon: SportsHandball,
    title: "Habits",
    route: "/habits",
    component: habits,
    permission: [],
  },
  {
    Icon: Group,
    title: "Customers",
    route: "/customers",
    component: customers,
    permission: [],
  },
  {
    Icon: EventIcon,
    title: "Events",
    component: events,
    route: "/events",
  },
  {
    Icon: FormatQuoteOutlined,
    title: "Quotes",
    route: "/quotes",
    component: quotes,
    permission: [],
  },
  {
    Icon: Forum,
    title: "Messaging",
    route: "/messaging",
    component: notifications,
    permission: [],
  },
  {
    Icon: CardGiftcard,
    title: "Magnets",
    route: "/lead-magnets",
    component: leadMagnets,
    permission: [],
  },
  {
    Icon: MovieFilter,
    title: "Media",
    component: mediaStudio,
    route: "/media-studio",
    permission: [],
  },
  // Tribed's own Second Brain atlas. `operatorOnly` hides it from the nav strip
  // for coaches (NavigationMenu filters on it); the brainAtlas function is the
  // real gate and 403s anyone outside a Tribed community.
  {
    Icon: BubbleChart,
    title: "Brain",
    route: "/brain",
    component: brain,
    permission: [],
    operatorOnly: true,
  },
  {
    Icon: Settings,
    title: "Settings",
    route: "/settings",
    component: configScreen,
    permission: [],
  },
  // Hidden from the nav strip (NavigationMenu filters on `hidden`) but still
  // registered as a route by MapAllowedRoutes. Reached from the toolbar icon.
  {
    Icon: ViewColumn,
    title: "Board",
    route: "/board",
    component: board,
    permission: [],
    hidden: true,
  },
];

export default items;
